import {
    colors, space, mediaQueries, borders
} from 'style/config';
import { MAX_PRODUCTS_STYLE, PRODUCT_SLOT_WIDTH, PRODUCT_SLOT_GAP } from 'components/Catalog/ProductGrid/CompareModal/constants';

export const zoneStyles = {
    zoneSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[2]}px`,
        paddingBottom: `${space[4]}px`,
        borderBottom: `${borders[1]} ${colors.lightGray}`
    },
    zoneSectionLast: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[2]}px`,
        paddingBottom: `${space[4]}px`,
        borderBottom: 'none'
    },
    zoneHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: `${space[2]}px`,
        marginBottom: `${space[2]}px`
    },
    productsContainer: {
        display: 'flex',
        gap: `${PRODUCT_SLOT_GAP}px`,
        alignItems: 'flex-start',
        minWidth: 'fit-content',
        width: `calc(${MAX_PRODUCTS_STYLE * PRODUCT_SLOT_WIDTH}px + ${(MAX_PRODUCTS_STYLE - 1) * PRODUCT_SLOT_GAP}px)`,
        [mediaQueries.sm]: {
            width: '100%',
            maxWidth: `calc(${MAX_PRODUCTS_STYLE * PRODUCT_SLOT_WIDTH}px + ${(MAX_PRODUCTS_STYLE - 1) * PRODUCT_SLOT_GAP}px)`,
            marginX: 'auto',
            justifyContent: 'center'
        }
    },
    productSlot: {
        flex: '0 0 auto',
        width: `${PRODUCT_SLOT_WIDTH}px`,
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[4]}px`,
        scrollSnapAlign: 'start'
    },
    zoneContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: `${space[2]}px`,
        minHeight: '40px'
    }
};
